import { topResults, allResults, recentResults, queryOnTypeRecent, moreResults, queryOnTypeMore, } from "../strings.locstring.json";
import loc from "owa-localize";
import type GroupHeader from "../type/GroupHeader";
import type { SearchTableQuery } from "owa-mail-list-search";
import type { TableView } from "owa-mail-list-store";
import { MailRowDataPropertyGetter } from "owa-mail-list-store";

/**
 * Get GroupHeader for row in search table
 * @param rowKey rowKey for which we want to lookup time group range
 * @param tableView tableView
 * @return group header for this row
 */
export default function getGroupHeaderForSearchTable(rowKey: string, tableView: TableView): GroupHeader {
    const searchTableQuery = tableView.tableQuery as SearchTableQuery;
    const isOriginalQueryOnTypeSubmittedSearch = tableView.isOriginalQueryOnTypeSectionRedesignEnabled &&
        searchTableQuery.scenarioType === "mail";
    
    // Checked before the sort order because these rows are sourced from a different backend and
    // deliberately ordered by date rather than by relevance, so the served table's sort order says
    // nothing about them.
    if (tableView.recentRowKeys?.includes(rowKey)) {
        const recentHeaderText = tableView.isOriginalQueryOnTypeSectionRedesignEnabled
            ? loc(queryOnTypeRecent)
            : loc(recentResults);
        
        return {
            headerText: () => recentHeaderText,
            headerId: recentHeaderText,
        };
    }
    
    if (tableView.moreResultsRowKeys?.includes(rowKey)) {
        const moreResultsHeaderText = loc(moreResults);
        
        return {
            headerText: () => moreResultsHeaderText,
            headerId: moreResultsHeaderText,
        };
    }
    
    if (isOriginalQueryOnTypeSubmittedSearch) {
        const moreHeaderText = loc(queryOnTypeMore);
        
        return {
            headerText: () => moreHeaderText,
            headerId: moreHeaderText,
        };
    }
    
    const sortOrder = MailRowDataPropertyGetter.getExecuteSearchSortOrder(rowKey, tableView);
    const currentHeaderText = <any>sortOrder == 1 || sortOrder === "Relevance" ? loc(topResults) : loc(allResults);
    
    return {
        headerText: () => currentHeaderText,
        headerId: currentHeaderText,
    };
}
